import React from 'react'
import styles from './OreMultiSelect.module.css'

interface OreMultiSelectTagCounterProps {
  count: number
  className?: string
  spanRef?: React.Ref<HTMLSpanElement>
}

export const OreMultiSelectTagCounter: React.FC<OreMultiSelectTagCounterProps> = ({ count, className, spanRef }) => {
  if (count <= 0) return null
  return (
    <span
      ref={spanRef}
      className={`${styles['ore-multiselect__tag']} ${styles['ore-multiselect__tag--counter']} ${className || ''}`}
    >
      +{count}
    </span>
  )
}
